import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    redirect: "/entry",
  },
  {
    path: "/entry",
    name: "entry",
    component: () =>
      import(/* webpackChunkName: "entry" */ "@/views/entry/index.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
  },
  {
    path: "/exam",
    name: "exam",
    meta: {
      quitExam: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/exam/index.vue"),
  },
];

const router = createRouter({
  routes,
  // history: createWebHashHistory(),
  history: createWebHistory(),
});

router.beforeEach((to, from, next) => {
  if (
    to.path == "/login" &&
    from.path == "/exam" &&
    !localStorage.getItem("userInfo")
  ) {
    console.log("1");

    next();
  } else if (to.path == "/exam" && !localStorage.getItem("userInfo")) {
    console.log("2");

    next("/");
  } else if (from.meta.quitExam) {
    console.log("3");
    // 假设需要数据保存验证
    alert("您已进入考试界面，无法点击后退，请点击交卷或重新登录");
    return false;
    // confirmLeave;
    // console.log("false");
    // next(false); // 阻止后退
  } else {
    console.log("4");
    next();
  }
});

export default router;
